import { Form, Button, Input } from 'antd';
import { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Loader } from '../../../../components/Loader';
import { PageHeader } from '../../../../components/PageHeader';

import { userActions } from '../../../../redux/user/actions';

import { required } from '../../../../constants/validation';
import { userRoles } from '../../../../constants/userRoles';

import { useUserData } from './useUserData';

import { UserEditActionButtons, SelectRole } from './style';

export const UserEdit = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { userFormData, loading, saving } = useUserData();

  useLayoutEffect(() => {
    form.setFieldsValue(userFormData);

    return () => form.resetFields();
  }, [form, userFormData]);

  const submitFinish = values => {
    dispatch(userActions.updateUser(userFormData._id, values));
  };

  const rolesOptions = Object.values(userRoles).map(role => ({ label: t(`roles.${role}`), value: role }));

  return (
    <>
      <PageHeader titleTranslationKey='users.editUserTitle' onBack={() => navigate('/front/users')} />
      <Loader loading={loading}>
        <Form
          name='userEdit'
          form={form}
          layout='vertical'
          requiredMark='optional'
          scrollToFirstError={true}
          onFinish={submitFinish}
        >
          <Form.Item name='email' label={t('users.email')} {...required}>
            <Input disabled />
          </Form.Item>
          <Form.Item name='name' label={t('users.name')} {...required}>
            <Input disabled />
          </Form.Item>
          <Form.Item name='roles' label={t('users.roles')} {...required}>
            <SelectRole mode='multiple' options={rolesOptions} />
          </Form.Item>
          <UserEditActionButtons>
            <Button onClick={() => navigate('/users')}>{t('global.cancel')}</Button>
            <Button type='primary' htmlType='submit' loading={saving}>
              {t('global.save')}
            </Button>
          </UserEditActionButtons>
        </Form>
      </Loader>
    </>
  );
};
